import { Box, Modal, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import React from "react";
import { PrimaryButton, SecondaryButton } from "../../../common/Buttons";
import { Circles } from "react-loader-spinner";
import { useTranslation } from "react-i18next";

const DeleteDataModal = (props) => {
  const {
    open,
    handleClose,
    deleteData,
    accountTypeId,
    selectedSubOwnerIndex,
    newFlow,
    handleDelete,
    focusedProperty = {},
    user,
    isLoading,
    extendedMessage,
  } = props;
  const { key } = focusedProperty;
  const { t } = useTranslation();
  return (
    <div>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          borderRadius={3}
          border="none"
          padding={3}
          width={600}
          position="absolute"
          left={0}
          right={0}
          top="35%"
          marginLeft="auto"
          marginRight="auto"
          bgcolor="background.paper"
        >
          <Box display="flex" justifyContent="flex-end">
            <Close
              sx={{
                cursor: "pointer",
              }}
              onClick={handleClose}
            />
          </Box>

          <Typography variant="h5" textAlign="center" marginX={10}>
            {t("delete-message-p1")} <b>{user}</b> {t("delete-message-p2")}
          </Typography>
          {extendedMessage ? (
            <Typography
              variant="h5"
              textAlign="center"
              marginX={10}
              color="red"
            >
              {extendedMessage}
            </Typography>
          ) : null}
          <Box display="flex" justifyContent="center" marginTop={3}>
            <PrimaryButton
              title={t("Cancel")}
              click={handleClose}
              fullWidth={false}
              borderRadius={4}
              padding="0.8rem 2rem"
            />
            <SecondaryButton
              title={t("Confirm")}
              click={async () => {
                if (newFlow) {
                  await handleDelete();
                } else {
                  deleteData(accountTypeId, selectedSubOwnerIndex, key);
                }
                handleClose();
              }}
              fullWidth={false}
              padding="0.8rem 2rem"
              borderRadius={4}
              border="3px solid #c298bb"
              marginLeft={3}
              isLoading={isLoading}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default DeleteDataModal;
